// todo: take constants from the server
export const DEFAULT_CHUNK_SIZE = 800;
export const MIN_CHUNK_SIZE = 1;
export const DEFAULT_CHUNK_OVERLAP = 400;
export const MIN_CHUNK_OVERLAP = 0;

export const DEFAULT_SENTENCE_COUNT = 1;
export const MIN_SENTENCE_COUNT = 1;
export const DEFAULT_WINDOW_SENTENCE_PADDING = 3;
export const MIN_WINDOW_SENTENCE_PADDING = 0;
export const DEFAULT_SENTENCE_MIN_LENGTH = 20;
export const MIN_SENTENCE_MIN_LENGTH = 1;
export const DEFAULT_SENTENCE_MAX_LENGTH = 800;
export const MIN_SENTENCE_MAX_LENGTH = 1;

export const DEFAULT_LLM_SPLITTER_PROMPT = `You are AI assistant, who can split documents into separate chunks by meaning.
You will be given the document text that needs to be split into chunks.
Remember while answering:
* The document consists of approximately {chunk_count} chunks.
* In the response, you need to return only the piece of text (10-12 words) that the chunk starts with. The response format is described below.

Response format:
chunk_1: {Chunk text}
chunk_2: {Chunk text}
...
chunk_N: {Chunk text}

Document text:
----
{document_text}
----

Answer:`;

export const DEFAULT_RETRIEVE_TOP_K = 2;
export const MIN_RETRIEVE_TOP_K = 1;

export const DEFAULT_CONTEXT_PROMPT_TEMPLATE = `You are a search AI assistant.  
You can have a friendly conversation with the user and answer his questions in markdown format.  
Remember while answering:
* You must respond in the language that you are asked in.
* Use information only from a list of verified sources.
* Consider the problem context, if it is not empty.
* Only display images if they are found in the verified sources.
* If the answer is not contained in verified sources or cannot be obtained from them, write about it with regret or ask a short clarifying question based on the sources.
* If the verified sources can answer the question in multiple different ways, ask a follow up question to clarify what the user wants to exactly to know about.
* Questions might be vague or have multiple interpretations, you must ask follow up questions in this case.

## Problem context:
{copilot_context}

## Verified sources:
{context_str}
`;

export const DEFAULT_PARAPHRASE_QUERY_GENERATION_PROMPT_TEMPLATE = `You are an AI assistant for generating multiple search queries based on a single input query.
Remember while answering:
* Generate {num_queries} search queries, one on each line, related to the following input query.
* Consider the problem context, if it is not empty.
* Consider the previous conversation of the assistant with the user, if it is not empty.

## Problem context:
{copilot_context}

## Previous conversation:
{chat_history}

## Input query:
{query}

## Queries:`;

export const DEFAULT_PARAPHRASE_NUM_QUERIES = 4;
export const MIN_PARAPHRASE_NUM_QUERIES = 1;

export const DEFAULT_TOKEN_LIMIT = 3000;
export const MIN_TOKEN_LIMIT = 1;

export const DEFAULT_SINGLE_SELECT_PROMPT_TMPL = `Some choices are given below. It is provided in a numbered list (1 to {num_choices}), where each item in the list corresponds to a summary.
---------------------
{context_list}
---------------------
Using only the choices above and not prior knowledge, return the choice that is most relevant to the question: '{query_str}'`;

export const DEFAULT_MULTI_SELECT_PROMPT_TMPL = `Some choices are given below. It is provided in a numbered list (1 to {num_choices}), where each item in the list corresponds to a summary.
---------------------
{context_list}
---------------------
Using only the choices above and not prior knowledge, return the top choices (no more than {max_outputs}, but only select what is needed) that are most relevant to the question: '{query_str}'`;

export const DEFAULT_LLM_RERANKER_CHOICE_SELECT_PROMPT_TEMPLATE = `You are a RAG (Retrieval-Augmented Generation) retrievals ranker.  
You will receive a query and several retrieved documents related to that query. Your task is to evaluate and score each document based on its relevance to the query provided.  
Remember while answering:
* Analyze each document by identifying key information and how it relates to the query.
* Consider whether the document provides direct answers, partial insights, or background context relevant to the query.
* Avoid assumptions — focus solely on the content provided.
* Possible document relevance scores (0 to 1, in increments of 0.1):
    0 = Completely Irrelevant: The document has no connection or relation to the query.
    0.1 = Virtually Irrelevant: Only a very slight or vague connection to the query.
    0.2 = Very Slightly Relevant: Contains an extremely minimal or tangential connection.
    0.3 = Slightly Relevant: Addresses a very small aspect of the query but lacks substantive detail.
    0.4 = Somewhat Relevant: Contains partial information that is somewhat related but not comprehensive.
    0.5 = Moderately Relevant: Addresses the query but with limited or partial relevance.
    0.6 = Fairly Relevant: Provides relevant information, though lacking depth or specificity.
    0.7 = Relevant: Clearly relates to the query, offering substantive but not fully comprehensive information.
    0.8 = Very Relevant: Strongly relates to the query and provides significant information.
    0.9 = Highly Relevant: Almost completely answers the query with detailed and specific information.
    1 = Perfectly Relevant: Directly and comprehensively answers the query with all the necessary specific information.

## Retrieved documents:
{context_str}

## Query:
{query_str}

## Answer:
`;
export const DEFAULT_LLM_RERANKER_CHOICE_BATCH_SIZE = 10;
export const MIN_LLM_RERANKER_CHOICE_BATCH_SIZE = 1;
export const DEFAULT_RERANK_TOP_K = 20;
export const MIN_RERANK_TOP_K = 1;

export const MIN_DOCUMENT_MAX_SIZE = 1;
